import { render, staticRenderFns } from "./TipoContatoCheck.vue?vue&type=template&id=59d04882&scoped=true&"
import script from "./TipoContatoCheck.vue?vue&type=script&lang=js&"
export * from "./TipoContatoCheck.vue?vue&type=script&lang=js&"
import style0 from "./TipoContatoCheck.vue?vue&type=style&index=0&id=59d04882&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d04882",
  null
  
)

export default component.exports